'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var accentuateGeneratePicture = exports.accentuateGeneratePicture = function accentuateGeneratePicture(image) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1400;
  var sizes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [500, 750, 1000];
  var clazz = arguments[3];
  var alt = arguments[4];
  var attributes = arguments[5];
  var lazy = arguments[6];
  var lazyExpand = arguments[7];

  attributes = attributes && attributes.length ? attributes : null;

  var ratios = [1, 2, 4];
  //TODO: Maybe we can enable some way of fetching the information about the
  //image here. (Mainly the image src, alt and dimensions if we can)
  var x = '<picture>';
  sizes.forEach(function (s, i) {
    x += '<source media="(';
    if (i != sizes.length - 1) {
      x += 'max-width';
    } else {
      x += 'min-width';
    }

    x += ':' + s + 'px)" ' + (lazy ? 'data-srcset' : 'srcset') + ' ="';

    ratios.forEach(function (r, y) {
      x += A_getImageUrl(image, s * r);
      if (r != 1) x += ' ' + r + 'x';
      if (y < ratios.length - 1) x += ', ';
    });

    if (alt) return x += '" ' + (lazy ? 'data-sizes="auto"' : '') + ' alt="' + alt + '" />';
    x += '" ' + (lazy ? 'data-sizes="auto"' : '') + ' />';
  });

  x += '<img ' + (lazy ? 'data-src' : 'src') + '="' + A_getImageUrl(image, width) + '" ';
  if (alt) x += 'alt="' + A_escapeString(alt) + '" ';
  if (clazz) x += 'class="' + clazz + ' ' + (lazy ? 'lazyload' : '') + '"';
  if (attributes) x += attributes + ' ';
  x += ' ' + (lazyExpand ? 'data-expand="' + lazyExpand + '"' : '') + '/></picture>';
  return x;
};

var A_getImageUrl = function A_getImageUrl(src, size) {
  if (!src) {
    //Source not specified / valid, return the no-image image.
    return '//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
  }

  size = '' + size; //Convert to string
  if (!size.endsWith('x')) size += 'x';

  var removeProtocol = function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  };
  if (!size) return src;
  if (size === 'master') return removeProtocol(size);

  // var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?.*)?$/i);
  if (!match) return null;

  var prefix = src.split(match[0]);
  var suffix = match[0];

  // removeProtocol(`${prefix[0]}_${size+suffix}`);
  return removeProtocol('' + prefix[0] + suffix);
};

var A_escapeString = function A_escapeString(s) {

  var TEXT_NODE = document.createTextNode("test");
  var TEXT_CONTAINER = document.createElement("span");
  TEXT_CONTAINER.appendChild(TEXT_NODE);

  TEXT_NODE.nodeValue = s;
  return TEXT_CONTAINER.innerHTML;
};